<template>
    
    <div ref="restrictedActionView" class="modal-body d-flex flex-column py-4 align-items-center justify-content-between">
        <ConfirmPassword v-if="!isPasswordVerified" :auto-submit="false" :uid="uid" @close-password-confirmation="close" @password-verification-status="passwordVerificationCheck"></ConfirmPassword>
        <Verification :type="twoFactorMethod" purpose="two_factor" :uid="uid" :user_id="user.id" :timer="expirySeconds" :allow-switching="canSwitchTwoFactorMethod" :allow_recovery_code="canUseRecoveryCodes" v-if="isPasswordVerified && !isTwoFactorVerified" @close-verification="close" @confirmation-status="twoFactorVerificationCheck"></Verification>

	    <ComponentRevokeSingleEmail v-if="(isPasswordVerified && isTwoFactorVerified) && action === 'revoke_session_from_email'" :data="data" @close-revoke-session-email="close"></ComponentRevokeSingleEmail>
    </div>
            
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import ConfirmPassword from "@/components/GenericModalAndViews/ConfirmPassword.vue";
import Verification from "@/components/GenericModalAndViews/Verification.vue";
import apiClient from "@/utils/axios.js";
import { useToast } from "@/composables/useToast.js";
import { useAppHelpers } from "@/composables/useAppHelpers.js";
import ComponentRevokeSingleEmail from "@/components/Auth/ComponentRevokeSingleEmail.vue";
import { useHttpErrorManager } from "@/composables/useHttpErrorManager.js";
import { useRouter } from "vue-router";

const props = defineProps({
	action: { type: String, required: true },
	dualAuthCheck: { type: Boolean, required: false, default: true },
	canUseRecoveryCodes: { type: Boolean, required: false, default: false },
	canSwitchTwoFactorMethod: { type: Boolean, required: false, default: false },
	data: { type: null, required: false, default: null },
	uid: { type: [String, Number], required: false, default: null }
});

const helper = useAppHelpers();
const { displayToast } = useToast();
const router = useRouter();

const restrictedActionView = ref(null);

const isPasswordVerified = ref(false);
const isTwoFactorVerified = ref(!props.dualAuthCheck);
const twoFactorMethod = ref('email');
const expirySeconds = ref(300);

const user = ref(null);
watch(() => props.dualAuthCheck, (value) => {
	updateTrustedDevice(value);
});

onMounted(async () => {
	await getUser();
});

const getUser = async () => {
	try{
		const response = await apiClient.post('auth/user/verification/getBasicUserData', {
			uid: props.uid
		});
		if (response.status >= 200 && response.status < 300) {
			user.value = response.data.userData;
			updateTwoFactorMethod(user.value.is_two_factor_enabled);
		}
	}
	catch (error) {
		await useHttpErrorManager().handleError(error, true);
		await close();
	}
}

const updateTrustedDevice = (status) => {
	isTwoFactorVerified.value = !!status;
}

const updateTwoFactorMethod = (status) => {
	if(status){
		twoFactorMethod.value = 'two_factor'
	}
	else{
		twoFactorMethod.value = 'email'
	}
}

const passwordVerificationCheck = async (status) => {
	if(status){
		if(twoFactorMethod.value !== 'two_factor'){
			await sendEmailTwoFactorCode();
		}
		isPasswordVerified.value = true;
	}
}

const twoFactorVerificationCheck = async (status) => {
	if(status[0]){
		isTwoFactorVerified.value = true;
	}
}

const sendEmailTwoFactorCode = async () => {
	try{
		const response = await apiClient.post('auth/resendVerificationCodeEmail', {
			user_id: user.value.id,
			purpose: 'two_factor_email'
		});
		if (response.status >= 200 && response.status < 300) {
			expirySeconds.value = response.data.expire_seconds;
		}

	}
	catch (error) {
	}
}

const close = async () => {
	await router.push({ name: 'home' });
}
</script>